import {useState,useEffect, useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import { exportToExcel } from '../../helpers/exporttoexcel';
import { saleServices } from "../../services/saleServices";
import {Titlebar,Searchbox,Orderstatus,Activiystatus} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import { Toast } from "primereact/toast";
import { TabMenu } from 'primereact/tabmenu';
import ProductNatureBadge from '../../components/categoriesindicator';
import {DynamicHorizontalTable} from '../../components/dynamictables';
import { Dialog } from 'primereact/dialog';


const Categories = () =>{
    const toast = useRef(null);
    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const [filters, setFilters] = useState({'currentPage':'1','pageSize':'10','status':'All'});
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    

    const [colDefs, setColDefs] = useState([
    { headerName: "SR NO",field: "id",width:100

     },
   
    { headerName: "Category",field: "category_name" },
    { headerName: "Product Nature",field: "product_nature" ,cellRenderer:(params)=>{
          return <ProductNatureBadge nature={params.getValue()}/>
    }},
    { headerName: "Status",field: "status",cellRenderer: (params) => {
          return <Activiystatus status={params.getValue()} />
      } },
      { headerName: "Date",field: "created_at" },
    
    
    { headerName: "Action",
    cellRenderer: (params) => {
      // console.log("params");
      // console.log(params.data.id);
      return (
        <>
             <button class="btn btn-primary btn-xs btn-white " onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note color-white"></i></button>&nbsp;
             <button class="btn btn-danger btn-xs btn-white btn-border-none" onClick={(e) => deletecateg(params.data.id)}><i class="icon icon-trash text-white" ></i></button>&nbsp; 
             <button class="btn btn-success btn-xs btn-white btn-border-none"><i class="icon icon-eye text-white" ></i></button>  

        </>
       
      );
    } }
  ]);

  useEffect(()=>{
    getCategoryData();
  },[])

  const editredirect = (id,data) =>{
    navigate(`/editcategory/${id}`, { state: { data: data } });
  }
  const deletecateg = async (id) =>{
    const response = await productservices.deletecategory(id);
    if(response.status == 200){
      await toast.current.show({ severity: 'success', summary: 'Category', detail: 'Deleted successfully' });
      getCategoryData(); 
    }
  }

   const getCategoryData = () =>{
    setUserloaded(true);
        productservices.getcategory().then((response) => {
            if(response.status == 200){
               setResults(response.data.data);
               setUserloaded(false);
            }
        }).catch((error) => {
            console.log("error : ", error);
            setUserloaded(true);
        });
    }

  const addproductnavigate = () =>{
    // navigate.  
    navigate('/addsale');
  }
  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:currentPage + 1
         } 
      });
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:currentPage - 1
         } 
      });
    }
  };
  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:newPage
         } 
      });
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    // getsalelist( 1, newSize);
    setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:1
         } 
    });
    
  };
    const items = [
   
    {
      label: 'All',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('All'),
    },
    {
      label: 'Active',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('active'),
    },
    {
      label: 'In Active',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('inactive'),
    },
    {
      label: 'Perishable',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('perishable'),
    },
     {
      label: 'Non Perishable',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('nonperishable'),
    },

    {
      label: 'Fragile',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('fragile'),
    },
     {
      label: 'Hazardous',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('hazardous'),
    },
   
  ];
  function handleStockFilter(status) {
     setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:1,
            status:status
         } 
      });   
    // getsalelist(1,pageSize,status);
  }

  useEffect(()=>{
           
    },[filters])

  const handleExport = () => {
     exportToExcel({ data: results, filename: 'stock' });
  }

  const onRowClicked = (event) => {
    setSelectedRow(event.data);
    // console.log(event.data,'row clicked data');
    setModalIsOpen(true);
  };

  return(
       <>
        <Toast ref={toast} />
          <Bredcrum title={'categories'} divider={false}/>
          <div class="row">
            
              <div className='col-md-12 mb-2 mt-2'>
                 <div className='flex-box flex-between'>
                      <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => navigate('/addcategory')}>Add Category</button> 
                      <div></div>
                     <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
                  </div> 
              </div> 


              <Dialog visible={modalIsOpen} position='top' modal style={{ width: '100rem' }} onHide={() => { if (!modalIsOpen) return; setModalIsOpen(false); }}>
                <div class="container">
                    {DynamicHorizontalTable({ data: selectedRow })}
                </div>
              </Dialog>
             
              
              {/* <Titlebar text={'Sales Overview'}/> */}
              <div className="col-md-12 mt-3">
                <div className='row'>
                      <div className='col-md-9'>
                        <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
                    </div> 
                     <div className='col-md-3'>
                        <div>
                          <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                            <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                        </div>
                      </div>
                </div>
               
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded}  quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} onRowClicked={onRowClicked}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Categories;